<template>
  <b-modal id="section-element-delete-modal" hide-footer centered>
    <template slot="modal-title">
      Удаление
    </template>
    <p v-if="topic !== null && section !== null">
      Вы уверены, что хотите удалить раздел:
      {{ sectionElementToDeleteTitle }}
    </p>
    <p v-else-if="topic !== null">
      Вы уверены, что хотите удалить тему:
      {{ content.topics[topic].title }}
    </p>
    <b-row class="mt-4">
      <b-col>
        <b-button block variant="primary" @click="onSectionDeleteClicked">
          Удалить
        </b-button>
      </b-col>
      <b-col><b-button block variant="outline-primary"
                       @click="$bvModal.hide('section-element-delete-modal')">
        Отмена</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DeleteSectionModal',
  props: {
    topic: {
      type: Number,
      default() {
        return null
      }
    },
    section: {
      type: Number,
      default() {
        return null
      }
    }
  },
  computed: {
    ...mapGetters({
      content: 'education/getCourseContent'
    }),
    sectionElementToDeleteTitle() {
      if (this.content.topics[this.topic].sections.length
        > this.section) {
        return this.content.topics[this.topic]
          .sections[this.section].title
      }
      return ''
    }
  },
  methods: {
    onSectionDeleteClicked() {
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>

</style>
